export default __webpack_public_path__ + "static/media/light.6952019e.svg";